export const API_ROUTES = {
  REPORT: '/api/reports',
  GET_CU_REPORT_BY_ID: (id: number) => `${API_ROUTES.REPORT}/${id}/static`,
} as const;
